export enum SemaphoreTypes {
  'LOAD_REQUEST' = '@semaphore/LOAD_REQUEST',
  'LOAD_SUCCESS' = '@semaphore/LOAD_SUCCESS',
  'LOAD_FAILURE' = '@semaphore/LOAD_FAILURE',
}
export type Severity = {
  protocolos?: number[];
  total: number;
};
export type Semaphore = {
  urgente: Severity;
  alta: Severity;
  media: Severity;
  baixa: Severity;
};

export interface SemaphoreState {
  readonly data: Semaphore[];
  readonly loading: boolean;
  readonly error: boolean;
}
